import { render, staticRenderFns } from "./Asterisk.vue?vue&type=template&id=6d034cef&"
import script from "./Asterisk.vue?vue&type=script&lang=js&"
export * from "./Asterisk.vue?vue&type=script&lang=js&"
import style0 from "./Asterisk.vue?vue&type=style&index=0&id=6d034cef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports